import { render } from "./TeamShowContainer.vue?vue&type=template&id=fd3b5ada"
import script from "./TeamShowContainer.vue?vue&type=script&lang=js"
export * from "./TeamShowContainer.vue?vue&type=script&lang=js"
script.render = render

export default script